export const RECENTS_PATH = "/users/recents";
export const TOKEN_PATH = "/search/tokens";
